/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const onboardingStepsSchema = z.record(z.string(), z.number());

export type IOnboardingSteps = z.infer<typeof onboardingStepsSchema>;
